import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';

const componentOptions = {
    bindings: {
        model: '=',
        modules: '=',
        view: '=',
        dataequalrow: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibCarbonFootprintBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-carbon-footprint-box-view.html';
    }]
};

const componentInfo = {
    module: 'ib-carbon-footprint-box-module',
    selector: 'ibCarbonFootprintBox',
    inject: ['$scope', '$rootScope', 'DatalayerUtilsService', 'DatalayerUniqueKeysService', 'DatalayerConstants', 'AncillariesConstants'],
    required: ['']
};
export class ibCarbonFootprintBox implements ng.IController {

    public model;

    constructor (
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerUniqueKeysService: DatalayerUniqueKeysService,
        private DatalayerConstants: DatalayerConstantsType,
        private AncillariesConstants: AncillariesConstant
    ) {}

    openModal = () => {
        this.emitAnalytics();
        this.$scope.$emit('openCarbonFootprintModal');
    };

    emitAnalytics = () => {
        if (this.DatalayerUniqueKeysService.exists(
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODULE_OPEN,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT)
        ) {
            return;
        }

        this.DatalayerUniqueKeysService.setValue(
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODULE_OPEN,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT
        );

        this.DatalayerUtilsService.updateDatalayerEvent(
            '',
            this.DatalayerConstants.DATALAYER_EVENT_TYPES.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.LABEL,
            this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.MODULE_CLICK
        );
    };
}


try {
    const mod = angular.module(componentInfo.module);
    ibCarbonFootprintBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibCarbonFootprintBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibCarbonFootprintBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibCarbonFootprintBox })
    );
}